// extracted by mini-css-extract-plugin
export default {"container":"AlreadyUserPopup__container--2IP","button":"AlreadyUserPopup__button--2yL","text":"AlreadyUserPopup__text--2Js"};